import * as React from 'react';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { getCurrency, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';

const style = require('./InvoiceRowDisplay.less');

// The Attention Dashboard's "Invoices Waiting for Approval" row. Its query is unscoped,
// so project invoices appear here too — and they have no work order, which is where this
// row used to read every field from. Same fallbacks as InvoiceRowDisplay: the invoice's
// own title then its project's, the invoice's location when the work order has none, and
// a currency that falls back to the supplier facility instead of formatting everything as
// USD.
export const PendingInvoiceRowDisplay: React.FC<any> = ({ invoice, ...props }) => {
	const title = nullSafeGetOrElse(
		'workOrder.title',
		invoice,
		nullSafeGetOrElse('title', invoice, nullSafeGet('project.title', invoice))
	);
	const locationName = nullSafeGetOrElse(
		'workOrder.location.name',
		invoice,
		nullSafeGet('location.name', invoice)
	);
	const currency = getCurrency({
		workOrder: nullSafeGet('workOrder', invoice),
		supplierFacility: nullSafeGet('supplierFacility', invoice),
	});

	return (
		<div className="invoiceRowDisplay" {...props} style={{ height: '55px', margin: '-8px -2px' }}>
			<div>
				<div className="invoiceRowDisplay__rowTitle">
					<Ellipsis tooltip={true} length={64} style={{ color: 'rgba(0,0,0,0.65)' }}>
						{title}
					</Ellipsis>
				</div>
				<div className="invoiceRowDisplay__rowSubtitle">
					{locationName ? (
						<div className="invoiceRowDisplay__rowInlineGroup" style={{ display: 'inline-flex' }}>
							<span className="invoiceRowDisplay__grayChip">
								<i className="icons8-font icons8-location-marker" />
								<span>{locationName}</span>
							</span>
						</div>
					) : null}
					<div className="invoiceRowDisplay__rowInlineGroup">
						{currency.format(invoice.invoiceTotalAfterTax)}
					</div>
				</div>
			</div>
		</div>
	);
};
